module.exports = __webpack_public_path__ + "static/media/about-people.34bf7b4f.png";